//工单申诉
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :isAppeal="true" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div >
          <vxe-grid show-overflow  :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                              @click="openEditDialog">工单导入
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top"
                              @click="openEditDialog">工单导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <!-- <div style="margin-right:15px">

<el-button type="primary" plain class="button-sty"  @click="zhiPaiDialog1 = true" icon="el-icon-s-grid">批量派单
</el-button>
<el-button type="primary" plain class="button-sty" @click="mapDialog1= true" icon="el-icon-location-information">地图派工
</el-button></div> -->
                  <el-input placeholder="请输入工单号或用户联系方式" style="width: 200px;     height: 27px !important;"
                            v-model="searchValue" @keyup.enter.native="searchEvent" clearable>
                    <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
                  </el-input>
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">
                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">
                      <path
                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"
                        fill="#0ea2f0" p-id="1588"></path>
                    </svg>
                    <span>更多筛选</span>
                  </div>

                  <!-- <i @click="show3 = !show3" v-if="!show3" class="el-icon-zoom-in" style="width: 50px;
    font-size: 20px;
    margin-top: 3px;
    margin-left: 5px;"></i> -->
                  <!-- <i @click="show3 = !show3" v-else class="el-icon-zoom-out" style="width: 50px;
    font-size: 20px;
    margin-top: 3px;
    margin-left: 5px;"></i> -->
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >
                  <vxe-form-item title="工单状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" :disabled="!enableStat" clearable  style="width:9vw ;">
                        <el-option :value="1" label="登记"></el-option>
                        <el-option :value="2" label="发布"></el-option>
                        <el-option :value="5" label="已派网点"></el-option>
                        <el-option :value="6" label="网点已接单"></el-option>
                        <el-option :value="9" label="已派师傅"></el-option>
                        <el-option :value="10" label="师傅已接单"></el-option>
                        <el-option :value="11" label="已预约"></el-option>
                        <el-option :value="13" label="已出发"></el-option>
                        <el-option :value="17" label="已上门"></el-option>
                        <el-option :value="20" label="完工暂存"></el-option>
                        <el-option :value="30" label="寄修待确认"></el-option>
                        <el-option :value="31" label="待寄件"></el-option>
                        <el-option :value="32" label="已寄待签收"></el-option>
                        <el-option :value="36" label="待维修"></el-option>
                        <el-option :value="37" label="修好待寄出"></el-option>
                        <el-option :value="38" label="客户待签收"></el-option>
                        <el-option :value="40" label="退换待确认"></el-option>
                        <el-option :value="41" label="旧机待退回"></el-option>
                        <el-option :value="42" label="旧机待签收"></el-option>
                        <el-option :value="43" label="旧机已签收"></el-option>
                        <el-option :value="44" label="新机待寄出"></el-option>
                        <el-option :value="45" label="新机已寄出"></el-option>
                        <el-option :value="47" label="新机待签收"></el-option>
                        <el-option :value="48" label="新机已签收"></el-option>
                        <el-option :value="49" label="退换被驳回"></el-option>
                        <el-option :value="61" label="已完工"></el-option>
                        <el-option :value="62" label="网点确认完工"></el-option>
                        <el-option :value="63" label="中心完工审核"></el-option>
                        <el-option :value="64" label="总部完工审核"></el-option>
                        <el-option :value="91" label="待结算"></el-option>
                        <el-option :value="92" label="结算驳回"></el-option>
                        <el-option :value="93" label="结算中止"></el-option>
                        <el-option :value="94" label="已结算"></el-option>
                        <el-option :value="97" label="申请关闭"></el-option>
                        <el-option :value="98" label="挂起"></el-option>
                        <el-option :value="99" label="取消"></el-option>
                        <el-option :value="100" label="结束"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="用户姓名:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.userName" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="服务类型:" field="name">
                    <template v-slot>
                      <service-type-cascader style="width:9vw;"
                                             @selectedServiceType="data => {formData.serviceTypeId = data}"/>
<!--                      <el-cascader style="width:9vw ;"-->
<!--                        v-model="formData.serviceTypeId"-->
<!--                        :options="serviceTypeOption"-->
<!--                        @change="serviceTypeHandleChange"></el-cascader>-->
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="品牌:" field="name">
                    <template v-slot>
                      <brand-select style="width:9vw;" :brand-id.sync="formData.brandId"/>
<!--                      <el-select v-model="formData.brandId" clearable  style="width:9vw ;">-->
<!--                        <el-option v-for="item in brandOptions" :key="item.value" :label="item.label"-->
<!--                                   :value="item.value">-->
<!--                        </el-option>-->
<!--                      </el-select>-->
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="配件状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.partsStat" clearable  style="width:9vw ;">
<!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="0" label="无配件"></el-option>
                        <el-option :value="1" label="申请"></el-option>
                        <el-option :value="2" label="审核"></el-option>
                        <el-option :value="3" label="出库"></el-option>
                        <el-option :value="4" label="网点收货"></el-option>
                        <el-option :value="8" label="驳回"></el-option>
                        <el-option :value="9" label="取消"></el-option>
                        <el-option :value="11" label="更换"></el-option>
                        <el-option :value="12" label="网点返厂"></el-option>
                        <el-option :value="13" label="返厂确认"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="服务中心:" field="name">
                    <org-search :org-name.sync="formData.orgName"
                                :org-id-path.sync="formData.orgIdPath"
                                :org-id.sync="formData.orgId"
                                style="width:9vw ;"/>
                  </vxe-form-item>

                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete style="width:9vw ;"
                        class="inline-input"
                        v-model="formData.siteName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect" @change="updateSiteName"
                      ></el-autocomplete>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="创建人:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.createBy" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="预约时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.bookDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="工单标签:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.dispatchStat" clearable  style="width:9vw ;">
                        <el-option v-for="item in dispatchStatOptions" :key="item.label" :label="item.label"
                                   :value="item.label">
                        </el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="工单来源:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.orderTypeId" clearable  style="width:9vw ;">
                        <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="保修类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.guaranteeType"  style="width:9vw ;" clearable>
<!--                        <el-option :value="null" label="全部"></el-option>-->
                        <el-option :value="1" label="保内"></el-option>
                        <el-option :value="2" label="保外"></el-option>
                        <el-option :value="3" label="未知"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="外部单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.outOrderNo" size="small" clearable  style="width:9vw ;" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;"  v-model="formData.completeDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="地区:" field="name">
                    <template v-slot>
                      <el-cascader :props="areaProps" v-model="formData.areaId" :clearable="true" style="width:9vw ;"
                                   @change="handleAreaChange" ref="cascaderAddr" />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="督办人:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.managerName" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #showStat="{row}">
              <span class="txt-status " v-if="row.stat == 1">登记</span>
              <span class="txt-status " v-else-if="row.stat == 2">发布</span>
              <span class="txt-status " v-else-if="row.stat == 5">已派网点</span>
              <span class="txt-status " v-else-if="row.stat == 6">网点已接单</span>
              <span class="txt-status " v-else-if="row.stat == 9">已派师傅</span>
              <span class="txt-status " v-else-if="row.stat == 10">师傅已接单</span>
              <span class="txt-status " v-else-if="row.stat == 11">已预约</span>
              <span class="txt-status " v-else-if="row.stat == 13">已出发</span>
              <span class="txt-status " v-else-if="row.stat == 17">已上门</span>
              <span class="txt-status neutral" v-else-if="row.stat == 20">完工暂存</span>
              <span class="txt-status neutral" v-else-if="row.stat == 30">寄修待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 31">待寄件</span>
              <span class="txt-status neutral" v-else-if="row.stat == 32">已寄待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 36">待维修</span>
              <span class="txt-status neutral" v-else-if="row.stat == 37">修好待寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 38">客户待签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 40">退换待确认</span>
              <span class="txt-status neutral" v-else-if="row.stat == 41">旧机待退回</span>
              <span class="txt-status neutral" v-else-if="row.stat == 42">旧机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 43">旧机已签收</span>
              <span class="txt-status neutral" v-else-if="row.stat == 44">新机待寄出</span>
              <span class="txt-status " v-else-if="row.stat == 45">新机已寄出</span>
              <span class="txt-status neutral" v-else-if="row.stat == 47">新机待签收</span>
              <span class="txt-status " v-else-if="row.stat == 48">新机已签收</span>
              <span class="txt-status disable" v-else-if="row.stat == 49">退换被驳回</span>
              <span class="txt-status " v-else-if="row.stat == 61">已完工</span>
              <span class="txt-status " v-else-if="row.stat == 62">网点确认完工</span>
              <span class="txt-status neutral" v-else-if="row.stat == 63">中心完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 64">总部完工审核</span>
              <span class="txt-status neutral" v-else-if="row.stat == 91">待结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 92">结算驳回</span>
              <span class="txt-status disable" v-else-if="row.stat == 93">结算中止</span>
              <span class="txt-status " v-else-if="row.stat == 94">已结算</span>
              <span class="txt-status disable" v-else-if="row.stat == 97">申请关闭</span>
              <span class="txt-status disable" v-else-if="row.stat == 98">挂起</span>
              <span class="txt-status disable" v-else-if="row.stat == 99">取消</span>
              <span class="txt-status disable" v-else-if="row.stat == 100">结束</span>

              <!-- <span v-if="row.urgeTimes>0" class="txt-status reminder">{{row.urgeTimes}}</span> -->


            </template>
            <template #option="{row}">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id, 'edit')">
                <el-tooltip enterable={false} effect="dark" content="编辑" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
              <span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="3" v-if="row.siteComplainStat===3&&initiateAppealA">发起申诉</el-dropdown-item>
                  <el-dropdown-item command="5" v-if="row.siteComplainStat===5&&centerReview">中心申诉审核</el-dropdown-item>
                  <el-dropdown-item command="7" v-if="row.siteComplainStat===7&&headquartersReview">总部申诉审核</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
    <preconditionDialog v-if="showPreconditionDialog" :visiable.sync="showPreconditionDialog" multi="true"/>

    <preconditionDialog2 v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" multi="true"/>
    <zhiPaiDialog v-if="zhiPaiDialog1" :visiable.sync="zhiPaiDialog1" multi="true"/>
    <mapDialog v-if="mapDialog1" :visiable.sync="mapDialog1" multi="true"/>
    <el-drawer
      title="发起申诉"
      :before-close="handleClose"
      :visible.sync="initiateAppeal"
      direction="rtl"
      custom-class="demo-drawer"
      ref="drawer"
    >
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="申诉原因" :label-width="formLabelWidth">
            <el-input type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8}" v-model="form2.appealRemark" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="申诉凭证" :label-width="formLabelWidth">
            <el-upload
              class="upload-demo"
              :action="api.uploadFileUrl"
              :on-success="(res,file, fileList) => {handleSuccess2(res,file, fileList)}"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :limit="3"
              :headers="headers"
              list-type="picture">
              <td align="left">
                <el-button  size="small" type="primary">点击上传</el-button>
              </td>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="toInitiateAppeal" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import editView from '../common/edit.vue';
import OrgSearch from "@/components/formItem/orgSearch.vue";
import preconditionDialog from '../common/dialog';
import preconditionDialog2 from '../common/dialog2.vue';
import mapDialog  from '../common/mapdialog.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import zhiPaiDialog from '@/views/dialogCommon/assignSiteDialog.vue';
import {echoFileFormat} from "@/util/uploadFormat";
import store from "@/store";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import BrandSelect from "@/components/formItem/brandSelect.vue";


export default {
  name: 'appeal',

  inject: ['reload'],
  components: {
    BrandSelect,
    ServiceTypeCascader,
    editView, pager, preconditionDialog, preconditionDialog2,zhiPaiDialog,mapDialog,OrgSearch},
  data() {
    return {
      total: 0,
      form2: {
        appealRemark: '',
      },
      formLabelWidth:'80px',
      picList1: [],
      picList2: [],
      picList3: [],
      searchValue: null,
      brandOptions: [],
      orderTypeOptions: [],
      // serviceTypeOption: [],
      initiateAppeal:false,
      dispatchStatOptions: [],
      orderId:'',
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      requestParam: {
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        stat: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchValueIsEnable: false,
        tabStat: '待申诉',

        serverTypeId: null,
        partsStat: null,
        siteId: null,
        createBy: null,
        bookDateBegin: null,
        bookDateEnd: null,
        orderTypeId: null,
        outOrderNo: null,
        dispatchStat: null,

        orgId:null,
        orgIdPath: null,
        orgName:null,

        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },

      formData: {
        areaId: null,
        brandId: null,
        orderNo: null,
        guaranteeType: null,
        userName: null,
        userMobile: null,
        userType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeDate: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        bookDate: null,
        bookDateBegin: null,
        bookDateEnd: null,
        searchValue: null,
        partsStat: null,
        stat: null,
        orderTypeId: null,
        serviceTypeId: [null],
        siteId: null,
        createBy: null,
        outOrderNo: null,
        managerName: null,
        orgName: null,
        orgIdPath:null,
        orgId:null,
        siteName: null,
        dispatchStat: null
      },
      show3: false,
      enableStat: false,
      sitePromptList: [],
      businessPhoto: [],
      goodsStatusList: [ //循环列表
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,
      zhiPaiDialog1:false,
      mapDialog1:false,
      fileList:[],



      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,

      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 100,
          field: 'siteComplainStat',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              //单子此时状态  和 能执行的操作     已申诉-此时状态
              if (row.siteComplainStat == 3) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id,'edit');
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">发起申诉</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ]
              } else if (row.siteComplainStat == 8) {  //单子此时状态  和 能执行的操作    执行考核-此时状态
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id,'edit');
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="2">再次申诉</el-dropdown-item>
                        <el-dropdown-item command="3">放弃申诉</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              } else if (row.status == 7) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id,'edit');
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                    <el-dropdown v-on:command={($event) => {
                      this.handleCommand(row, $event)
                    }}>
												<span class="el-dropdown-link">
													<i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
												</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="3">总部申诉审核</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                ];
              }
            }
          }
        },

        {
          title: '工单号',
          field: 'orderNo',
          width: 180,
          slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        {
          title: '服务类型',
          field: 'serverTypeName',
          width: 80,
        },
        { title: '状态', field: 'stat', width: 150, slots: { default: 'showStat' } },
        {
          title: '催单次数', field: 'urgeTimes', width: 80, slots: {
            default: ({ row }) => {
              if(row.urgeTimes>0){
              return [<span>{row.urgeTimes}</span>
              ]}else  {
                return [
              0
                ];
              }
            }
          }
        },

        {
          title: '用户姓名',
          field: 'userName',
          width: 80,
        },
        {
          title: '联系方式',
          field: 'userMobile',
          width: 120,
        },
        
        {
          title: '地区',
          field: 'area',
          width: 180,
          slots: {
            default: ({row}) => {
              return [<span>{row.userProvice}{row.userCity}{row.userCounty}{row.userTown}</span>]
            }
          }
        },
        {
          title: '品牌',
          field: 'brandName',
          width: 100,
          // fixed: 'left'
        },
        {
          title: '产品大类',
          field: 'bigCategoryName',
          width: 80,
        },
        {
          title: '保修类型',
          field: 'guaranteeType',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.guaranteeType == 1) {
                return [
                  <div class="txt-status ">
                    <span>保内</span>
                  </div>
                ];
              } else if (row.guaranteeType == 2) {
                return [
                  <div class="txt-status disable">
                    <span>保外</span>
                  </div>
                ];
              } else if (row.guaranteeType == 3) {
                return [
                  <div class="txt-status neutral">
                    <span>未知</span>
                  </div>
                ];
              }
            }
          }
        },



        {
          title: '服务中心',
          field: 'orgName',
          width: 100,
          // fixed: 'left'
        },        {
          title: '服务商',
          field: 'siteName',
          width: 100,
          // fixed: 'left'
        },
        {title: '工程师', field: 'engineerName', width: 100,},
        {
          title: '回访状态',
          field: 'recallStat',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.recallStat == 0) {
                return [
                  <div class="txt-status disable">
                    <span>未回访</span>
                  </div>
                ];
              } else if (row.recallStat == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>已抽样</span>
                  </div>
                ];
              } else if (row.recallStat == 2) {
                return [
                  <div class="txt-status ">
                    <span>已回访</span>
                  </div>
                ];
              } else if (row.recallStat == 5) {
                return [
                  <div class="txt-status ">
                    <span>用户已评价</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '工单标签',
          field: 'siteComplainStat',
          width: 125,
          slots: {
            default: ({row}) => {
              if (row.siteComplainStat == 0) {
                return [
                  <div class="txt-status ">
                    <span>无申诉</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 3) {
                return [
                  <div class="txt-status neutral">
                    <span>待申诉</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 5) {
                return [
                  <div class="txt-status ">
                    <span>已申诉</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 7) {
                return [
                  <div class="txt-status ">
                    <span>中心已审核</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 8) {
                return [
                  <div class="txt-status disable">
                    <span>中心驳回</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 9) {
                return [
                  <div class="txt-status ">
                    <span>总部已处理</span>
                  </div>
                ];
              } else if (row.siteComplainStat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '创建人',
          field: 'siteFee',
          width: 80,
        },
        {
          title: '创建时间',
          field: 'createTime',
          width: 150,
        },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.bookDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.bookDateBegin = newVal[0]
          this.formData.bookDateEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.bookDateBegin = null
          this.formData.bookDateEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.centerReview = this.permissions["centerReview"];
    this.initiateAppealA = this.permissions["initiateAppeal"];
    this.headquartersReview = this.permissions["headquartersReview"];
  },

  mounted() {
    this.loadBrandOption()
    this.loadTabOption()
    this.loadOrderTypeOption()
    // this.loadServiceTypeOptions()
    this.loadDispatchStatOptions()
  },

  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    api() {
      return api
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadTabOption()

    },

    loadDispatchStatOptions() {
      this.$http({
        url: api.basDispatchStat.getList,
        method: 'post',
        data: {
          isShow: 1  //工单查询栏目是否显示:0否1是
        }
      }).then(res => {
        this.dispatchStatOptions = []
        res.data.data.forEach(item =>  {
          this.dispatchStatOptions.push({label:item.dispatchStat})
        })
      })
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    async toInitiateAppeal() {
      try {
        this.loading = true;
        this.$mask.open()

        // 发送请求
        const res = await axios.post(api.soOrder.toInitiateAppeal, {orderId: this.orderId, appealRemark: this.form2.appealRemark,piclist:this.fileList});
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.orderId='';
          this.fileList = [];
          this.form2.appealRemark = '';
          this.cancelForm()
          this.flushed()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('系统错误，请稍后重试');
      } finally {
        this.loading = false;
        this.$mask.close()

      }
      this.$mask.close()

    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    // // 加载服务类型
    // loadServiceTypeOptions() {
    //   this.$http({
    //     url: api.basServiceType.getOptionUrl,
    //     method: 'post',
    //     data: {}
    //   }).then(res => {
    //     // console.log(res.data.data, 'option')
    //     let list = []
    //     res.data.data.forEach(item => {
    //       if (item.children.length == 0) {
    //         delete item.children
    //       }
    //       list.push(item)
    //     })
    //     this.serviceTypeOption = list
    //   })
    // },

    // 加载工单来源
    loadOrderTypeOption() {
      this.$http({
        url: api.basOrderType.getListUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.orderTypeOptions = []
        res.data.data.forEach(item => {
          this.orderTypeOptions.push({
            value: item.id,
            label: item.orderTypeName
          })
        })
      })
    },

    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.soOrder.getCountUrlByAppeal,
        method: 'post',
        data: {}
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      this.requestParam.tabStat = this.goodsStatusItem

      this.enableStat = item.name === '所有'

      this.flushed()
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.soOrder.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.searchValueIsEnable = !this.show3

      this.requestParam.searchValue = this.searchValue
      this.requestParam.brandId = this.formData.brandId
      this.requestParam.guaranteeType = this.formData.guaranteeType
      this.requestParam.orderNo = this.formData.orderNo
      this.requestParam.userName = this.formData.userName
      this.requestParam.userType = this.formData.userType
      this.requestParam.userMobile = this.formData.userMobile
      this.requestParam.createTimeBegin = this.formData.createTimeBegin
      this.requestParam.createTimeEnd = this.formData.createTimeEnd
      this.requestParam.completeTimeBegin = this.formData.completeTimeBegin
      this.requestParam.completeTimeEnd = this.formData.completeTimeEnd
      this.requestParam.stat = this.formData.stat
      this.requestParam.serverTypeId = this.formData.serviceTypeId[this.formData.serviceTypeId.length - 1]
      this.requestParam.partsStat = this.formData.partsStat
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.createBy = this.formData.createBy
      this.requestParam.bookDateBegin = this.formData.bookDateBegin
      this.requestParam.bookDateEnd = this.formData.bookDateEnd
      this.requestParam.orderTypeId = this.formData.orderTypeId
      this.requestParam.areaId = this.formData.areaId
      this.requestParam.outOrderNo = this.formData.outOrderNo
      this.requestParam.managerName = this.formData.managerName
      this.requestParam.dispatchStat = this.formData.dispatchStat
      this.requestParam.orgId = this.formData.orgId
      this.requestParam.orgIdPath = this.formData.orgIdPath
      this.requestParam.orgName = this.formData.orgName


      // this.requestParam.stat = this.formData.stat
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleAreaChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },

    updateSiteName(){
      this.formData.siteName=null
      this.formData.siteId=null
      this.requestParam.siteId==null
    },



    ///////////////////////////////////////////////////////////////////////////////////////////////////


    addressClickEvent(row, id) {
      this.openEditDialog(row.id);
    },
    // 选中的按钮

    // 考核备注
    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    // 打开考核弹窗
    handleCommand(command, b) {
      this.orderId = command.id;
      if (b == 1) {
        this.initiateAppeal = true;
      } else if (b == 2) {
        this.initiateAppeal = true;
      } else if (b == 3){
        this.$confirm('是否放弃申诉,该工单将挂起并取消结算？')
          .then(_ => {
            abandonAppeal(this.orderId);
          })
          .catch(_ => {
            this.cancelForm();
          });
      }
    },

    abandonAppeal(id){
      this.$http({
        url: api.soOrder.abandonAppeal,
        method: 'post',
        data: {
          orderId:id,
        }
      }).then(res => {
        this.$message.success('操作成功')
        this.flushed()
      })
    },

    open() {
      this.$prompt('请填写考核备注', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        //   inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        //   inputErrorMessage: '邮箱格式不正确'
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '你的添加的考核备注是: ' + value
        });
        this.reload()// 需要刷新页面
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
        this.reload()// 需要刷新页面
      });

    },
    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },

    // handleImageChange(fileList) {
    //   if (fileList.length > 1) {
    //     fileList.splice(0, 1);
    //   }
    // },
    // handleRemove1() {
    //   this.picList1 = []
    // },
    // handleSuccess1(res, file, fileList) {
    //   console.log(res.data.url, "url")
    //   this.picList1 = echoFileFormat(res.data.url)
    // },
    // handleRemove2() {
    //   this.picList1 = []
    // },
    handleSuccess2(res, file, fileList) {
      this.fileList.push(res.data.url)
    },
    // handleRemove3() {
    //   this.picList3 = []
    // },
    // handleSuccess3(res, file, fileList) {
    //   console.log(res.data.url, "url")
    //   this.picList3 = echoFileFormat(res.data.url)
    // },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },

    // // 分页功能
    // changeTablePage(page, flag) {
    //   console.log('分页数据', page, this.formData)
    //   this.formData.size = page.pageSize
    //   this.formData.current = page.currentPage
    //   this.formData.searchCount = flag
    //   this.initTableList();
    // },
    // // 搜索
    // searchEvent() {
    //   this.$refs['table-m1'].commitProxy('reload');
    //
    // },
    // // 重置
    // resetEvent() {
    //   this.formData = {};
    //   this.formData.addresswangdian = {};
    //   this.$refs['table-m1'].commitProxy('reload');
    // },
    // 新增
    openEditDialog(id, type) {
      this.editViewType = type
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row.id, 'info')
    },

    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/soOrder/getListPage',
        param: this.formData,
        method: 'post',


      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);

      this.$refs['table-m1'].commitProxy('reload');
    },
  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
// 隐藏搜索栏
.screen-box{
  display: flex;



}
::v-deep .vxe-grid .vxe-form.screen-box {
    padding: 4px 10px 2px 0;
    }
::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}

</style>
